import { api } from 'src/api'

const fetchTripById = async (id: string) => {
  const response = await api.get(`/travel/find?id=${id}`)
  const travel = response.data[0]
  return travel
}

export const TripApi = { fetchTripById }
